import { default as BSModal } from 'bootstrap/js/src/modal'

class Modal extends BSModal {}

export default Modal
